import { WidgetProps } from '@rjsf/utils';

/* */
const HiddenConstantWidget = function (props: WidgetProps) {
  if (props.value != props.schema.const) {
    props.onChange(props.schema.const);
  }

  return(
    <input
      type="hidden"
      value={props.value}
      required={props.required}
      onChange={(event) => props.onChange(event.target.value)}
    />
  );
};

export { HiddenConstantWidget };
